import { FileType } from "@sb-shared/models/file-type";

export enum FileTypeId {
    PDF = 1,
    CSV = 2
}

// Order and icon colours match the legacy sb-export-button: CSV (Excel green) first, then PDF (red).
export const FileTypes: FileType[] = [
    {
        id: FileTypeId.CSV,
        label: 'CSV',
        mime: 'text/csv;charset=utf-8',
        format: '.csv',
        iconName: 'file-excel',
        iconClass: 'file-excel',
        iconColor: '#217346'
    },
    {
        id: FileTypeId.PDF,
        label: 'PDF',
        mime: 'application/pdf',
        format: '.pdf',
        iconName: 'file-pdf',
        iconClass: 'file-pdf',
        iconColor: '#fa0f00'
    }
]